module.exports = __webpack_public_path__ + "assets/img/pdf-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/pdf-icon.svg
// module id = 450
// module chunks = 0